import { useRouter } from "next/router";


const ShopAtMOOIMOM = () => {
  const router = useRouter();

  return (
    <div
      className="fixed bottom-10 right-0 bg-mooimom p-2 rounded-l-lg z-30 cursor-pointer"
      onClick={() => router.push("/")}
    >
      <p className="text-white font-poppins font-semibold text-xs md:text-base">Shop at MOOIMOM</p>
    </div>
  )
}

export default ShopAtMOOIMOM
